import { HttpHandlerFn, HttpRequest, HttpInterceptorFn, HttpEvent } from '@angular/common/http';
import { Observable, tap } from 'rxjs';

export const successInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
  return next(req).pipe(
    tap({
      next: (event) => {
        // Success interceptor - no-op, just logs successful responses
        // Backend returns raw data, Angular HttpClient will parse it
      },
      error: (error) => {
        // Errors are handled by errorInterceptor
      },
    })
  );
};
